<template>
  <v-container>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ t("dashboard.title") }}</v-toolbar-title>
      </v-toolbar>

      <v-container>
        <v-row>
          <v-col v-if="unsubmittedCampaigns || dashboard.todo_wins.count">
            <v-card color="red-lighten-2">
              <v-card-title>
                <div>
                  <h5 class="text-h5">
                    {{ t("dashboard.heading_todo") }}
                  </h5>
                </div>
              </v-card-title>
              <v-table>
                <thead>
                  <tr>
                    <th>
                      {{ t("dashboard.tableheader_todo_type") }}
                    </th>
                    <th>
                      {{ t("dashboard.tableheader_count") }}
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="unsubmittedCampaigns">
                    <td>{{ t("dashboard.todo_unsubmitted") }}</td>
                    <td>
                      {{
                        t("dashboard.number", {
                          value: unsubmittedCampaigns,
                        })
                      }}
                    </td>
                    <td>
                      <v-btn
                        variant="text"
                        icon
                        :to="{
                          name: 'campaigns-list',
                          params: {
                            merchantIdent: currentMerchant.uuid,
                          },
                          query: {
                            filter_status: 'created',
                          },
                        }"
                        ><v-icon>mdi-arrow-right</v-icon></v-btn
                      >
                    </td>
                  </tr>
                  <tr v-if="dashboard.todo_wins.count">
                    <td>{{ t("dashboard.todo_wins") }}</td>
                    <td>
                      {{
                        t("dashboard.number", {
                          value: dashboard.todo_wins.count,
                        })
                      }}
                    </td>
                    <td>
                      <v-btn
                        variant="text"
                        icon
                        :href="dashboard.todo_wins.winner_app_url"
                        target="_blank"
                        ><v-icon>mdi-arrow-right</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>

          <v-col sm="6" md="6" lg="6" xl="6">
            <v-card>
              <v-card-title>
                <div>
                  <h5 class="text-h5">
                    {{ t("dashboard.heading_sweepstakes") }}
                  </h5>
                </div>
              </v-card-title>

              <v-table>
                <thead>
                  <tr>
                    <th>
                      {{ t("dashboard.tableheader_status") }}
                    </th>
                    <th>
                      {{ t("dashboard.tableheader_count") }}
                    </th>
                    <th>
                      {{ t("dashboard.tableheader_sweep_total_value") }}
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in sweepstakesOverview" :key="i">
                    <td>
                      {{ t("campaign.list.status__" + item.status) }}
                    </td>
                    <td>
                      {{ t("dashboard.number", { value: item.count }) }}
                    </td>
                    <td>
                      {{ t("dashboard.currency", { value: item.sweeptotal }) }}
                    </td>
                    <td>
                      <v-btn
                        variant="text"
                        icon
                        :to="{
                          name: 'campaigns-list',
                          params: {
                            merchantIdent: currentMerchant.uuid,
                          },
                          query: {
                            filter_type: 'sweepstake/standard',
                            filter_status: item.status,
                          },
                        }"
                        ><v-icon>mdi-arrow-right</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>

          <v-col xs="12" sm="6" md="6" lg="6" xl="6">
            <v-card>
              <v-card-title>
                <div>
                  <h5 class="text-h5">{{ t("dashboard.heading_coupons") }}</h5>
                </div>
              </v-card-title>

              <v-table>
                <thead>
                  <tr>
                    <th>
                      {{ t("dashboard.tableheader_status") }}
                    </th>
                    <th>
                      {{ t("dashboard.tableheader_count") }}
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in couponsOverview" :key="i">
                    <td>
                      {{ t("campaign.list.status__" + item.status) }}
                    </td>
                    <td>
                      {{ t("dashboard.number", { value: item.count }) }}
                    </td>
                    <td>
                      <v-btn
                        variant="text"
                        icon
                        :to="{
                          name: 'campaigns-list',
                          params: {
                            merchantIdent: currentMerchant.uuid,
                          },
                          query: {
                            filter_type: 'coupon',
                            filter_status: item.status,
                          },
                        }"
                        ><v-icon>mdi-arrow-right</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>

          <v-col xs="12" sm="6" md="6" lg="6" xl="6">
            <v-card>
              <v-card-title>
                <div>
                  <h5 class="text-h5">{{ t("dashboard.heading_users") }}</h5>
                </div>
              </v-card-title>
              <v-table>
                <thead>
                  <tr>
                    <th>
                      {{ t("dashboard.tableheader_usercounttype") }}
                    </th>
                    <th>
                      {{ t("dashboard.tableheader_count") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in userRows" :key="i">
                    <td>{{ t("dashboard.users__" + row) }}</td>
                    <td>
                      {{
                        t("dashboard.number", {
                          value: dashboard.users[row] || 0,
                        })
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" xl="6">
            <v-card>
              <v-card-title>
                <div>
                  <h5 class="text-h5">{{ t("dashboard.heading_views") }}</h5>
                </div>
              </v-card-title>
              <v-table>
                <thead>
                  <tr>
                    <th>
                      {{ t("dashboard.tableheader_viewcounttype") }}
                    </th>
                    <th>
                      {{ t("dashboard.tableheader_count") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in viewRows" :key="i">
                    <td>{{ t("dashboard.views__" + row) }}</td>
                    <td>
                      {{
                        t("dashboard.number", {
                          value: dashboard.users[row] || 0,
                        })
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                <div>
                  <h5 class="text-h5">{{ t("dashboard.heading_chart") }}</h5>
                </div>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="2">
                    <date-picker
                      :input="tfStartInput"
                      @update:result="tfStartInput = $event"
                      field="tfStart"
                      :label="t('dashboard.chart_startdate')"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="tfRange"
                      :items="tfRangeOpts"
                      :label="t('dashboard.chart_range_select')"
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="1">
                    <v-text-field
                      v-model="tfCount"
                      type="number"
                      :label="t('dashboard.chart_range_count')"
                      min="1"
                      max="30"
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="3" v-if="tfCampaignsAvail.length > 0">
                    <v-select
                      v-model="tfCampaigns"
                      :items="tfCampaignOpts"
                      :label="t('dashboard.chart_campaings')"
                      multiple
                      variant="outlined"
                      clearable
                      :rules="[
                        () => {
                          if (tfCampaigns.length > 9) {
                            return false;
                          } else {
                            return true;
                          }
                        },
                      ]"
                    >
                      <template v-slot:selection="{ item, index }">
                        <template v-if="item.value">
                          <span v-if="tfCampaigns.length < 3 && index < 2">
                            {{ item.title }}
                          </span>
                        </template>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="1">
                    <v-switch
                      v-model="chartDistinctUser"
                      :label="t('dashboard.chart_participations')"
                      inset
                    />
                  </v-col>
                </v-row>
              </v-container>
              <LineChart
                v-if="chartLoaded"
                :chart-data="chartData"
                :chart-labels="chartLabels"
                :chart-options="chartOptions"
              />
              <v-card>
                <v-card-title>
                  <div>
                    <h5 class="text-h5">Raw User Kids</h5>
                  </div>
                </v-card-title>
                <v-container v-if="rawUsersKids.kid_gender">
                  <div>
                    <h4>Person Gender</h4>
                    <pre>{{rawUsersKids.person_gender.debug}}</pre>
                  </div>
                  <div>
                    <h4>Youngest Kid Gender</h4>
                    <pre>{{rawUsersKids.youngest_kid_gender.debug}}</pre>
                  </div>
                  <div>
                    <h4>Youngest Kid Age</h4>
                    <pre>{{rawUsersKids.youngest_kid_age.debug}}</pre>
                  </div>
                  <div>
                    <h4>All Kids Gender</h4>
                    <pre>{{rawUsersKids.kid_gender.debug}}</pre>
                  </div>
                  <div>
                    <h4>All Kids Age</h4>
                    <pre>{{rawUsersKids.kid_age.debug}}</pre>
                  </div>
                  <PieChart
                    v-if="chartLoaded"
                    :chart-data="rawUsersKids.kid_age.data"
                    :chart-labels="rawUsersKids.kid_age.labels"
                    :chart-options="chartOptions"
                  />
                </v-container>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import {
  apiDashboard,
  apiStats,
  apiGetTimeframeCampaigns,
} from '@/api/merchant.js'
import LineChart from '@/components/generic/LineChart.vue'
import PieChart from '@/components/generic/PieChart.vue'
import DatePicker from '@/components/generic/DatePicker.vue'
import { formatISO } from 'date-fns'

const { t } = useI18n()
const authStore = useAuthStore()

const dashboard = reactive({
  campaigns: [],
  users: {},
  todo_wins: {},
})

const userRows = [
  'day',
  'month',
  'year',
  'total',
  'total_participations',
  'total_user_participations',
]
const viewRows = ['total_list_views', 'total_detail_views', 'total_mail_views']

const chartLoaded = ref(false)
const chartData = ref([])
const chartLabels = ref([])
const chartOptions = ref({ responsive: true })
const chartDistinctUser = ref(false)
const tfCampaignsAvail = ref([])
const tfCampaigns = ref([])
const tfStartInput = ref(formatISO(Date.now(), { representation: 'date' }))
const tfStart = ref(formatISO(Date.now(), { representation: 'date' }))
const tfRange = ref('month')
const tfCount = ref(1)
const tfRangeList = ['month', 'week', 'year']
const rawUsersKids = ref({})

const currentMerchant = computed(() => authStore.currentMerchant)
const merchantLevel = computed(() => authStore.merchantLevel)

const sweepstakesOverview = computed(() => {
  return dashboard.campaigns.filter((data) => data.type === 'sweepstake')
})

const couponsOverview = computed(() => {
  return dashboard.campaigns.filter((data) => data.type === 'coupon')
})

const unsubmittedCampaigns = computed(() => {
  return dashboard.campaigns.reduce(function (accumulator, currentValue) {
    if (currentValue.status === 'created') {
      return accumulator + currentValue.count
    } else {
      return accumulator
    }
  }, 0)
})

const tfRangeOpts = computed(() => {
  return genSelectOpts(tfRangeList, 'dashboard.sel_lbl_element_tfrange__')
})

const tfCampaignOpts = computed(() => {
  return genSelCampaigns(tfCampaignsAvail.value)
})

watch(currentMerchant, () => {
  fetchData()
})

watch(tfStartInput, (val) => {
  tfStart.value = formatISO(val, { representation: 'date' })
  loadTimeframeCampaigns()
  loadChartData()
})

watch(tfRange, () => {
  loadTimeframeCampaigns()
  loadChartData()
})

watch(tfCount, () => {
  loadTimeframeCampaigns()
  loadChartData()
})

watch(tfCampaigns, () => {
  loadChartData()
})

watch(chartDistinctUser, () => {
  loadChartData()
})

onMounted(() => {
  fetchData()
})

const fetchData = async () => {
  if (currentMerchant.value.uuid) {
    const data = await apiDashboard(currentMerchant.value.uuid)
    dashboard.campaigns = data.campaigns
    dashboard.users = data.users
    dashboard.todo_wins = data.todo_wins
    await loadTimeframeCampaigns()
  }
}

const loadChartData = async () => {
  let args = {
    timerange: tfRange.value,
    count: tfCount.value,
    start: tfStart.value,
  }
  if (tfCampaigns.value.length > 0) {
    args.campaign = tfCampaigns.value
  }
  if (chartDistinctUser.value) {
    args.distinct = 'participations'
  }
  const rv = await apiStats(currentMerchant.value.uuid, args)
  const participations = rv.participations
  chartData.value = participations.data
  chartLabels.value = participations.labels
  chartLoaded.value = true
  rawUsersKids.value = rv.users_kids
}

const loadTimeframeCampaigns = async () => {
  const c = await apiGetTimeframeCampaigns(currentMerchant.value.uuid, {
    timerange: tfRange.value,
    count: tfCount.value,
    start: tfStart.value,
  })
  if (c.campaigns) {
    let campaigns = []
    c.campaigns.forEach((el) => {
      campaigns.push(el.id)
    })
    tfCampaigns.value = campaigns.slice(0, 9)
    tfCampaignsAvail.value = c.campaigns
  }
}

const genSelectOpts = (items, i18n) => {
  let opts = []
  items.forEach((el) => {
    opts.push({ title: t(i18n + el), value: el })
  })
  return opts
}

const genSelCampaigns = (items) => {
  let opts = []
  items.forEach((el) => {
    opts.push({ title: el.title, value: el.id })
  })
  return opts
}
</script>
